import authReducer from "./authReducer";

const rootReducer = {
  auth: authReducer,
};

export default rootReducer;
